module.exports = __webpack_public_path__ + "media/images/icons/bike-6fb75b87ef3bd9c3efa797be9f806c4d.svg";